import AppDataService from "./AppDataService";

export default class SettingsService {
  static async getDrugList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.medicineName ? `medicineName=${data.medicineName}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`mastercode/medicine${queryString}`);
  }

  static async postDrugData(data) {
    return await AppDataService.post(`mastercode/medicine`, data);
  }

  static async patchDrugData(drugId, data) {
    return await AppDataService.patch(`mastercode/medicine/${drugId}`, data);
  }

  static async deleteDrug(id) {
    return await AppDataService.delete(`mastercode/medicine/${id}`);
  }

  static async getCodeList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.diagnosisName
        ? `diagnosisName=${encodeURIComponent(data.diagnosisName)}`
        : "",
      data?.type ? `type=${data?.type}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`mastercode${queryString}`);
  }

  static async postCodeData(data) {
    return await AppDataService.post(`mastercode`, data);
  }

  static async patchCodeData(codeId, data) {
    return await AppDataService.patch(`mastercode/${codeId}`, data);
  }

  static async deleteCode(id) {
    return await AppDataService.delete(`mastercode/${id}`);
  }

  static async getTemplateList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.type ? `type=${data?.type}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/template${queryString}`);
  }

  static async postTemplateData(data) {
    return await AppDataService.post(`admin/template`, data);
  }

  static async patchTemplateData(templateId, data) {
    return await AppDataService.patch(`admin/template/${templateId}`, data);
  }

  static async uploadTemplateData(data) {
    const queryParams = [
      data?.type ? `type=${data.type}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.post(`admin/template/upload${queryString}`, {
      file: data.file,
    });
  }
  static async postUserData(data) {
    return await AppDataService.post(`admin/user`, data);
  }

  static async getAdminUsers(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `searchValue=${data.name}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");
    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/user${queryString}`);
  }

  static async patchAdminUsersData(id, data) {
    return await AppDataService.patch(`admin/user/${id}`, data);
  }

  static async deleteAdminUser(id) {
    return await AppDataService.delete(`admin/user/${id}`);
  }

  static async uploadAdminUsersFile(fileData) {
    return await AppDataService.post(`admin/user/upload/bulk`, fileData);
  }

  static async sendAdminUserInvitation(id) {
    return await AppDataService.post(`user/send-invitation`, { id });
  }

  static async sendAdminUserBulkInvitation(ids) {
    return await AppDataService.post(`user/send-invitation/bulk`, {
      ids,
      isAdmin: true,
    });
  }

  static async getDataImportData(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      //data?.name ? `searchValue=${data.name}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");
    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`admin/data-import${queryString}`);
  }

  static async postDataImportData(data) {
    return await AppDataService.post(`admin/data-import`, data);
  }

  static async patchDataImportData(id, data) {
    return await AppDataService.patch(`admin/data-import/${id}`, data);
  }

  static async getRolesResponsibilityList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`role${queryString}`);
  }

  static async postRolesResponsibilityData(data) {
    return await AppDataService.post(`role`, data);
  }

  static async patchRolesResponsibilityData(roleId, data) {
    return await AppDataService.patch(`role/${roleId}`, data);
  }

  static async deleteRolesResponsibility(id) {
    return await AppDataService.delete(`role/${id}`);
  }

  static async postMasterRole(data) {
    return await AppDataService.post(`master-role`, data);
  }

  static async patchMasterRole(masterRoleId, data) {
    return await AppDataService.patch(`master-role/${masterRoleId}`, data);
  }

  static async deleteMasterRole(masterRoleId) {
    return await AppDataService.delete(`master-role/${masterRoleId}`);
  }

  static async getMasterRoleList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`master-role${queryString}`);
  }

  static async getOrderTypeList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.status ? `status=${data?.status}` : "",
      data?.facilityId ? `facilityId=${data?.facilityId}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`order-type${queryString}`);
  }

  static async postOrderType(data) {
    return await AppDataService.post(`order-type`, data);
  }

  static async patchOrderType(orderTypeId, data) {
    return await AppDataService.patch(`order-type/${orderTypeId}`, data);
  }

  static async deleteOrderType(orderTypeId) {
    return await AppDataService.delete(`order-type/${orderTypeId}`);
  }

  static async getMasterDataList(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.searchValue ? `searchValue=${data.searchValue}` : "",
      data?.type ? `type=${data?.type}` : "",
      data?.status ? `status=${data?.status}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`master-data${queryString}`);
  }

  static async postMasterData(data) {
    return await AppDataService.post(`master-data`, data);
  }

  static async patchMasterData(id, data) {
    return await AppDataService.patch(`master-data/${id}`, data);
  }

  static async deleteMasterData(id) {
    return await AppDataService.delete(`master-data/${id}`);
  }

  static async getAdminUserForProfile(id) {
    return await AppDataService.get(`admin/user/${id}`);
  }

  static async patchAdminProfileData(id, data) {
    return await AppDataService.patch(`admin/user/${id}`, data);
  }

  // Communication Rule APIs
  static async createCommunicationRule(data) {
    return await AppDataService.post(`communication-rule`, data);
  }

  static async getCommunicationRules(data) {
    const queryParams = [
      data?.pageNumber >= 0 ? `pageNumber=${data.pageNumber}` : "",
      data?.limit ? `limit=${data.limit}` : "",
      data?.name ? `name=${data.name}` : "",
      data?.facilityId ? `facilityId=${data.facilityId}` : "",
      data?.providerId ? `providerId=${data.providerId}` : "",
    ]
      .filter(Boolean)
      .join("&");

    const queryString = queryParams ? `?${queryParams}` : "";
    return await AppDataService.get(`communication-rule${queryString}`);
  }

  static async getCommunicationRuleById(ruleId) {
    return await AppDataService.get(`communication-rule/${ruleId}`);
  }

  static async updateCommunicationRule(ruleId, data) {
    return await AppDataService.patch(`communication-rule/${ruleId}`, data);
  }

  static async deleteCommunicationRule(ruleId) {
    return await AppDataService.delete(`communication-rule/${ruleId}`);
  }
}
